export enum CreditCardType {
  VISA = 'VISA',
  MASTER_CARD = 'MASTER_CARD'
}
